<script setup lang="ts">
import { useConfigStore } from '@/stores/config';
import { storeToRefs } from 'pinia';

const { config } = storeToRefs(useConfigStore())
</script>

<template>
  <v-bottom-navigation app grow :bg-color="config?.backgroundColor" :height="$vuetify.display.mobile ? 56 : 80">
    <slot />
  </v-bottom-navigation>
</template>